import { render } from "./tep-tv-table-group.vue?vue&type=template&id=25aadc6b&scoped=true"
import script from "./tep-tv-table-group.vue?vue&type=script&setup=true&lang=js"
export * from "./tep-tv-table-group.vue?vue&type=script&setup=true&lang=js"

import "./tep-tv-table-group.vue?vue&type=style&index=0&id=25aadc6b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25aadc6b"],['__file',"src/views/tep/tep-grid/components/tep-tv-table-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25aadc6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25aadc6b', __exports__)) {
    api.reload('25aadc6b', __exports__)
  }
  
  module.hot.accept("./tep-tv-table-group.vue?vue&type=template&id=25aadc6b&scoped=true", () => {
    api.rerender('25aadc6b', render)
  })

}


export default __exports__